import { render } from "./Concept_page.vue?vue&type=template&id=5421ff0e&scoped=true"
import script from "./Concept_page.vue?vue&type=script&lang=js"
export * from "./Concept_page.vue?vue&type=script&lang=js"

import "./Concept_page.vue?vue&type=style&index=0&id=5421ff0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5421ff0e"

export default script